import Vue from 'vue'
import App from './App.vue'
import router from './router'

import store from './store'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import './plugins/vue-world-map'
import vuetify from './plugins/vuetify'
import i18n from './i18n'

import axios from './axios'
import VueAxios from 'vue-axios'

import VueAuth from '@websanova/vue-auth'
import VueAuthBearer from '@websanova/vue-auth/drivers/auth/bearer.js'
import VueAuthAxios from '@websanova/vue-auth/drivers/http/axios.1.x.js'
import VueAuthRouter from '@websanova/vue-auth/drivers/router/vue-router.2.x.js'

Vue.router = router
Vue.use(VueAxios, axios)
Vue.use(VueAuth, {
    auth: VueAuthBearer,
    http: VueAuthAxios,
    router: VueAuthRouter,
    rolesVar: 'roles',
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
